import Vue from "vue";
import Vuex from "vuex";
import API from "../api";

const _ = require("lodash");

Vue.use(Vuex);

async function HandleError(callback) {
  try {
    await callback();
  } catch (e) {
    throw e.response.data;
  }
}
const Instance = {
  namespaced: true,
  state: {
    dfcDataList: {
      // paginatioin
      total: 0,
      list: [],
    },
    ruleForm: {},
  },
  mutations: {},
  actions: {
    async getDFCResourceList({ state }, query) {
      await HandleError(async () => {
        state.dfcDataList = (await API.GetDFCResourceList(query)).data;
      });
    },
    async createDFCResource({ state }, { query, data }) {
      await HandleError(async () => {
        state.dfcDataList = (await API.createDFCResource(query, data)).data;
      });
    },
    async updateDFCResource({ state }, { query, data }) {
      await HandleError(async () => {
        state.dfcDataList = (await API.updateDFCResource(query, data)).data;
      });
    },
    async deleteDFCResource({ state }, { query, id }) {
      await HandleError(async () => {
        state.dfcDataList = (await API.deleteDFCResource(query, id)).data;
      });
    },
    async getDFCResourceDetailLink({ state }, { link }) {
      return (await API.GetDFCResourceDetailLink(link)).data;
    },
    async getDFCResourceDetailUser({ state }, { account }) {
      return (await API.GetDFCResourceDetailUser(account)).data;
    },
  },
};

export default Instance;
